import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import { REDUX_PERSIST_STORE } from '../utils/constants'
import appReducer from './appReducer'
import authReducer from './authReducer'

const rootReducer = combineReducers({
  auth: authReducer,
  app: appReducer,
})

const persistedReducer = persistReducer({
  key: REDUX_PERSIST_STORE,
  storage,
}, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware(getDefaultMiddleware) {
    return getDefaultMiddleware({ serializableCheck: false })
  },
})

export const persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch

export default store
